'use client';

import { useEffect, useState } from 'react';
import { tooltipStore } from '../stores/tooltipStore';

// Returns reactive tooltip global state.
export function useOnboardingTooltipState() {
  const [, forceUpdate] = useState({});

  useEffect(() => {
    const unsubscribe = tooltipStore.subscribe(() => {
      forceUpdate({});
    });
    return () => {
      unsubscribe();
    };
  }, []);

  return {
    tooltipsEnabled: tooltipStore.isTooltipsEnabled(),
    hasAnyFeatureEnabled: tooltipStore.hasAnyFeatureEnabled(),
    hasAnyTargetedFeatureEnabled: tooltipStore.hasAnyTargetedFeatureEnabled(),
  };
}
